import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Card, CardBody, Button, Input, Spinner, Label } from 'reactstrap';

import { connect } from 'react-redux';
import {
  getCustomVouchersCommission,
  saveCustomVouchersCommission,
} from '../../../../actions/admin';

const TableHeight = 500;

class CustomVouchersTab extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    roles: PropTypes.shape(),
    sortAdminPayments: PropTypes.func.isRequired,
    fetchPayments: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
    roles: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      loading: false,
      customVouchersCommission: null,
    };
  }

  componentDidMount() {
    const { fetchCustomVouchersCommission } = this.props;

    fetchCustomVouchersCommission().then((res) => {
      const { customVouchersCommissionSetting } = this.props;

      this.setState({ customVouchersCommission: customVouchersCommissionSetting });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { adminSettings } = nextProps;

    console.log('adminSettings', adminSettings);

    if (adminSettings && adminSettings.customVouchersCommission) {
      this.setState({ customVouchersCommission: adminSettings.customVouchersCommission.commission });
    }
  }

  save = () => {
    const { updateCustomVouchersCommission } = this.props;
    const { customVouchersCommission } = this.state;

    this.setState({ buttonPressed: true });

    updateCustomVouchersCommission(customVouchersCommission);

    this.timeoutID = setTimeout(() => {
      this.setState({ buttonPressed: null });
    }, 200);
  }

  handleChange = (e) => {
    if (e.target && e.target.name) {
      const { name, value } = e.target;

      if (name) {
        this.setState({
          [name]: value || '',
        });
      }
    }
  };

  render() {
    const {
      customVouchersCommission,
      buttonPressed,
    } = this.state;

    return (
      <div>
        <Card>
          <CardBody>
            <Row>
              <Col xs="12">
                <Label style={{ display: 'inline-block', width: 'fit-content' }} className="basic-information-label" for="customVouchersCommission">Custom voucher fee (commission %)</Label>
                <Input
                  style={{ width: 140, display: 'inline-block' }}
                  name="customVouchersCommission"
                  value={customVouchersCommission}
                  onChange={this.handleChange}
                />
                <div style={{ display: 'inline-block', width: 'fit-content', position: 'relative', top: 12, marginLeft: 8 }}>
                  <Button color="primary" className="basic-information-x-button" onClick={this.save}>
                    Save
                    {buttonPressed ? (
                      <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                    ) : (null)}
                  </Button>
                </div>
              </Col>

              <Col xs="12">

              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  customVouchersCommissionSetting: state.admin.customVouchersCommissionSetting || null,
});

const mapDispatchToProps = {
  fetchCustomVouchersCommission: getCustomVouchersCommission,
  updateCustomVouchersCommission: saveCustomVouchersCommission,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomVouchersTab));
